var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "info_svg__st0",
    d: "M12 2c5.5 0 10 4.5 10 10s-4.5 10-10 10S2 17.5 2 12 6.5 2 12 2m0-2C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "info_svg__st0",
    d: "M12 9.4c-.6 0-1.1.5-1.1 1V18c0 .6.5 1 1.1 1 .6 0 1.1-.5 1.1-1v-7.6c0-.6-.5-1-1.1-1z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "info_svg__st0",
    cx: 12,
    cy: 6.5,
    r: 1.5
  })));
};
export default SvgInfo;